import { render } from "./MW2023Background.vue?vue&type=template&id=109f9fe7"
import script from "./MW2023Background.vue?vue&type=script&lang=js"
export * from "./MW2023Background.vue?vue&type=script&lang=js"

import "./MW2023Background.vue?vue&type=style&index=0&id=109f9fe7&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__